import React from "react";
import { BlackButton } from "../../Buttons/BlackButton";
import {useTranslation} from "react-i18next";

export const MaxHourlyRateWarning = ({ isOpen, onClose, onConfirm, branchRate, freelancerRate }) => {
    const {t} = useTranslation();
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full">
                <h2 className="text-lg font-bold mb-4">Waarschuwing</h2>
                <p className="mb-4">
                    Het maximale uurtarief dat je voor deze shift kan ontvangen is <span className="font-bold">€{branchRate}</span>.
                    Jouw uurtarief is <span className="font-bold">€{freelancerRate}</span>.<br/>
                    Wil je toch doorgaan met je kandidatuur?
                </p>
                <div className="flex justify-end gap-2">
                    <button
                        className="px-4 py-2 rounded bg-gray-200 text-gray-700"
                        onClick={onClose}
                    >{t('general.actions.cancel')}</button>
                    <BlackButton onClick={onConfirm}>{t('general.actions.confirm')}</BlackButton>
                </div>
            </div>
        </div>
    );
};

